// Point d'entree principal du front (ex-f.js / s.js).
//
// Architecture : tout le coeur est en modules ES (import/export). Ce fichier :
//   1. lit la config injectee par le serveur via window.__GOWEB__ ;
//   2. initialise Config (environnement) et instancie BasketHelper ;
//   3. reexpose une facade globale window.Goweb pour les rares scripts inline
//      des vues (.cshtml) qui appellent encore Goweb.Helper.TokenHelper, etc.
//
// jQuery / Kendo / Leaflet restent des globals charges par leurs <script>.

import { Config, setConfig } from "./_config/Config";
import { ConfigDevelopment } from "./_config/config.development";
import { ConfigTest } from "./_config/config.test";
import { UserRights } from "./_config/UserRights";
import { TokenHelper } from "./Helper/TokenHelper";
import { AnchorHelper } from "./Helper/AnchorHelper";
import { BasketHelper } from "./Helper/BasketHelper";
import { JsonFetch, TextFetch, BlobFetch } from "./Helper/FetchHelper";
import * as Shared from "./Tools/Misc";
import { Delegate } from "./Tools/Delegate";

// Selectionne la config selon l'environnement fourni par le serveur.
const env = window.__GOWEB__?.Environment ?? "Development";
setConfig(env === "Test" ? ConfigTest : ConfigDevelopment);
setConfig({ Environment: env });

// Facade globale minimale : reproduit les chemins historiques Goweb.* encore
// utilises par du JavaScript inline dans certaines vues (_Layout, Monetico,
// Account/Connexion). Le code applicatif, lui, passe par les imports ESM.
const Goweb = {
    Config,
    UserRights,
    JsonFetch,
    TextFetch,
    BlobFetch,
    Delegates: { Delegate },
    Shared,
    BasketHelper,
    Helper: {
        TokenHelper,
        AnchorHelper,
    },
};

declare global {
    interface Window {
        Goweb: typeof Goweb;
        // Resolue une fois window.Goweb pret. Les <script> inline classiques des
        // vues (qui s'executent avant ce module differe) doivent attendre cette
        // promesse avant d'appeler Goweb.* : window.gowebReady.then(() => ...).
        gowebReady: Promise<typeof Goweb>;
        // Resolver de gowebReady, pose par le _Layout avant le chargement du module.
        __gowebResolve?: (goweb: typeof Goweb) => void;
    }
}

window.Goweb = Goweb;

// Instancie le panier (ex-`const a = Goweb.BasketHelper.Instance;` du _Layout).
BasketHelper.Instance;

// Signale aux scripts inline que la facade Goweb est disponible.
window.__gowebResolve?.(Goweb);
